export const SETTINGS_KEY = 'historicalOwnership';
export const DEFAULT_FILE_NAME = 'Historical Ownership Overview Report';
export const REPORT_FILTERS_FT = 'historical-ownership-report-filters-SKYL-2303';
